module["exports"] = [
  "ie",
  "com",
  "net",
  "info",
  "eu"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/internet/domain_suffix.js
// module id = 1171
// module chunks = 1